module.exports = __webpack_public_path__ + "assets/img/swiper-1-1.b4756706.jpg";